import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { selectPersistStateInit } from '@datorama/akita';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { from, Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

/**
 * NgxPermissionsGuard checks roles that are loaded from the persisted auth state, but
 * guards in the same canActivate array run concurrently, so on a cold load it can
 * evaluate the pre-hydration (empty) permission set and fail open. This wrapper delays
 * the permission check until the persisted stores have rehydrated. Only needed where
 * NgxPermissionsGuard runs alongside OfflineInitialisedGuard; child routes of a gated
 * parent can keep using NgxPermissionsGuard directly.
 */
@Injectable({
  providedIn: 'root',
})
export class HydratedPermissionsGuard implements CanActivate {
  constructor(private permissionsGuard: NgxPermissionsGuard) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return selectPersistStateInit().pipe(
      take(1),
      switchMap(() => from(Promise.resolve(this.permissionsGuard.canActivate(route, state))))
    );
  }
}
